import { Component, OnInit } from '@angular/core';
import { SearchObject } from '../../services/Rest';
import { BaseComponent } from '../base/base.component';
import { forkJoin, Subscription } from 'rxjs';


import {Stock_Record} from '../../models/RestModels';
import {Item} from '../../models/RestModels';
import {Order_Item} from '../../models/RestModels';
import {Store} from '../../models/RestModels';
import {Shipping_Item} from '../../models/RestModels';
import {Purchase_Detail} from '../../models/RestModels';
import {ItemInfo, StockRecordInfo} from 'src/app/models/models';
import {Utils} from 'src/app/classes/Utils';
import { ExcelUtils } from 'src/app/classes/ExcelUtils';


export const STOCK_RECORD_EXPORT_PAGE_SIZE = 500;
export const ADJUSTMENT_REPORT_MAX_HOURS = 24;
export const STOCK_RECORD_DEFAULT_INITIAL_DAYS = 7;

export function getDefaultStockRecordStartDate(now: Date = new Date(),
	days_before: number = STOCK_RECORD_DEFAULT_INITIAL_DAYS): Date
{
	let d = new Date( now.getTime() );
	d.setDate( d.getDate() - days_before );
	d.setHours( 0, 0, 0, 0 );
	return d;
}

export function validateAdjustmentReportRange(start: Date | null, end: Date | null,
	max_hours: number = ADJUSTMENT_REPORT_MAX_HOURS): string | null
{
	if( start == null || end == null || isNaN( start.getTime() ) || isNaN( end.getTime() ) )
		return 'Seleccione fecha de inicio y fin válidas';

	if( start.getTime() >= end.getTime() )
		return 'La fecha de inicio debe ser anterior a la fecha final';

	if( (end.getTime() - start.getTime()) > max_hours*3600*1000 )
		return 'El rango máximo del reporte es de '+max_hours+' horas';

	return null;
}

export function resolveReportStoreId(search_store_id: number | string | null | undefined,
	current_store_id: number, has_global_stock: number | boolean): number
{
	if( !has_global_stock || search_store_id === null || search_store_id === undefined || search_store_id === '' )
		return current_store_id;

	let parsed = typeof search_store_id === 'number' ? search_store_id : parseInt( ''+search_store_id, 10 );

	return isNaN( parsed ) ? current_store_id : parsed;
}

@Component({
	selector: 'app-list-stock-record',
	templateUrl: './list-stock-record.component.html',
	styleUrls: ['./list-stock-record.component.css']
})

export class ListStockRecordComponent extends BaseComponent implements OnInit {
	file:File | null = null;
	show_import:boolean = false;
	stock_record_search:SearchObject<Stock_Record> = this.getEmptySearch();
	stock_record_info_list:StockRecordInfo[] = [];

	fecha_inicial:string = '';
	fecha_final:string = '';

	item_list:Item[] = [];
	order_item_list:Order_Item[] = [];
	store_list:Store[] = [];
	shipping_item_list:Shipping_Item[] = [];
	purchase_detail_list:Purchase_Detail[] = [];
	search_str:string = '';
	type_dic:Record<string,string> ={
		POSITIVE: 'Positivo',
		NEGATIVE: 'Negativo',
		ADJUSTMENT: 'Ajuste'
	};
	show_modal_report: boolean = false;
	start_time: string	= '';
	end_time: string	= '';
	is_exporting: boolean = false;
	is_generating_report: boolean = false;
	export_progress: number = 0;
	report_progress: number = 0;
	private export_subscription: Subscription | null = null;
	private report_subscription: Subscription | null = null;

	ngOnInit()
	{
		this.path = '/list-stock-record';

		this.subs.sink = this.route.queryParamMap.subscribe((queryParamMap) =>
		{
			let fields = [
				"item_id","purchase_detail_id","order_item_id","store_id","shipping_item_id",
				"production_item_id","serial_number_record_id","previous_qty","movement_qty"
				,"qty", "description","movement_type","created_by_user_id","updated_by_user_id",
				"created","updated"
			];

			let extra_keys:Array<string> = ['item_name'];

			this.stock_record_search = this.getSearch(queryParamMap, fields, extra_keys );
			this.setTitle('Bitacora de inventario');
			this.stock_record_search.sort_order = ['id_DESC'];


			if( !this.rest.current_permission.global_add_stock )
			{
				this.stock_record_search.eq.store_id = this.rest.current_user.store_id;
			}

			if( queryParamMap.has('ge.created') )
			{
				let str = Utils.getLocalMysqlStringFromDate( this.stock_record_search.ge.created ).substring(0,10);

				this.fecha_inicial	= str;
			}
			else
			{
				let def = getDefaultStockRecordStartDate();
				this.stock_record_search.ge.created = def;
				this.fecha_inicial	= Utils.getLocalMysqlStringFromDate( def ).substring(0,10);
			}

			if( !queryParamMap.has('eq.movement_type') )
			{
				this.stock_record_search.eq.movement_type = undefined;
			}

			if( queryParamMap.has('le.created') )
			{

				let str = Utils.getLocalMysqlStringFromDate( this.stock_record_search.le.created ).substring(0,10);

				this.fecha_final = str;
				console.log('Fecha final', this.fecha_final, this.stock_record_search.le.created );
			}
			else
			{
				this.fecha_final = '';
			}

			//if( !this.rest.current_permission.view_stock || !this.rest.current_permission.view_global_stocktake )
			//{
			//	this.rest.showError('No cuentas con el permiso de ver inventarios');
			//	return;
			//}

			this.is_loading = true;

			this.subs.sink = forkJoin
			({
				stock_record_info: this.rest.stock_record_info.search(this.stock_record_search),
				store : this.rest.getStores( true ),
			})
			.subscribe((responses)=>
			{
				if( this.stock_record_search.eq.item_id )
				{
					if( responses.stock_record_info.data.length )
					{
						let sri = responses.stock_record_info.data[0];
						let str = (sri.category ? sri.category.name+' - ': '')+sri.item.name;
						this.search_str = str;
					}
				}
				this.is_loading = false;
				this.stock_record_info_list = responses.stock_record_info.data;
				this.setPages( this.stock_record_search.page, responses.stock_record_info.total );
				this.store_list = responses.store.data;
			},(error)=>this.showError(error));
		});
	}

	onItemSelected(item_info:ItemInfo)
	{
		this.stock_record_search.eq.item_id = item_info.item.id;
	}

	exportXls()
	{
		if( this.is_exporting || this.is_generating_report )
			return;

		let new_search:SearchObject<Stock_Record> = { ...this.stock_record_search};
		new_search.page = 0;

		this.is_exporting = true;
		this.export_progress = 0;
		this.is_loading = true;

		let update_lambda = (counter: number, total: number) =>
		{
			this.export_progress = total > 0 ? Math.round( ((counter+1)/total)*100 ) : 0;
		};

		if( this.export_subscription )
			this.export_subscription.unsubscribe();

		this.export_subscription = this.rest.stock_record_info
		.searchAllWithProgress( new_search, STOCK_RECORD_EXPORT_PAGE_SIZE, false, update_lambda )
		.subscribe((response)=>{
			let rows:any[] = response.data.map(i=> {
				let Referencia = '';

				if( i.shipping )
					Referencia += 'Envio '+i.shipping.id;

				if( i.order )
					Referencia += 'Venta '+i.order.id;

				if( i.purchase )
					Referencia += 'Orden De Compra'+i.purchase.id;

				if( i.stock_record.movement_type == 'ADJUSTMENT')
					Referencia += 'Ajuste inventario';

				let tipo = 'Negativo';

				if( i.stock_record.movement_type == 'ADJUSTMENT')
				{
					tipo = 'Ajuste';
				}
				else if( i.stock_record.movement_type == 'POSITIVE')
				{
					tipo = 'Positivo'
				}

				return {
					id: i.stock_record.id,
					Fecha: Utils.getMysqlStringFromLocalDate(i.stock_record.created).substring(0,10),
					Categoría: i?.category?.name,
					Artículo: i.item.name,
					Sucursal: i.store.name,
					Usuario: i.user.name,
					Referencia,
					Tipo: tipo,
					Previo: i.stock_record.previous_qty,
					Movimiento: i.stock_record.movement_qty,
					Cantidad: i.stock_record.qty,
					Descripción: i.stock_record.description,
				}
			});
			let str = Utils.getMysqlStringFromLocalDate(new Date() ).substring(0,10)+'.xlsx';
			let headers:string[] = [
				'id','Fecha','Categoría','Artículo',
				'Sucursal','Usuario','Referencia',
				'Previo', 'Movimiento','Cantidad',
				'Descripción'
			];
			ExcelUtils.array2xlsx( rows, str, headers );
			this.is_exporting = false;
			this.is_loading = false;
		},(error)=>{
			this.is_exporting = false;
			this.is_loading = false;
			this.showError(error);
		});

		this.subs.sink = this.export_subscription;
	}

	cancelExport()
	{
		if( this.export_subscription )
		{
			this.export_subscription.unsubscribe();
			this.export_subscription = null;
		}
		this.is_exporting = false;
		this.is_loading = false;
	}

	cancelReport()
	{
		if( this.report_subscription )
		{
			this.report_subscription.unsubscribe();
			this.report_subscription = null;
		}
		this.is_generating_report = false;
	}

	fechaInicialCambio(str:string)
	{
		this.fecha_inicial = str;
		if( str == '' )
		{
			this.stock_record_search.ge.created = null;
		}
		else
		{
			this.stock_record_search.ge.created = Utils.getDateFromLocalMysqlString( str+' 00:00:00');
		}
	}

	fechaFinalCambio(str:string)
	{
		this.fecha_final= str;
		if( str == '' )
		{
			this.stock_record_search.le.created = null;
		}
		else
		{
			this.stock_record_search.le.created = Utils.getDateFromLocalMysqlString( str+' 23:59:59' );
		}
	}

	saveAll()
	{
	}
	showModalReport()
	{
		let start	= new Date();
		start.setHours(0,0,0,0);


		let end = new Date();
		end.setMinutes(end.getMinutes()+61);
		end.setMinutes(0);
		end.setSeconds(0);
		end.setMilliseconds(0);


		this.start_time = Utils.getMysqlStringFromLocalDate( start ).replace(' ','T');
		this.end_time = Utils.getMysqlStringFromLocalDate( end ).replace(' ','T');;
		this.show_modal_report = true;
	}
	createReport()
	{
		if( this.is_generating_report || this.is_exporting )
			return;

		let start = Utils.getLocalDateFromMysqlString( this.start_time );
		let end = Utils.getLocalDateFromMysqlString( this.end_time );

		let range_error = validateAdjustmentReportRange( start, end );

		if( range_error || start == null || end == null )
		{
			if( range_error )
				this.showWarning( range_error );
			return;
		}

		let ss = this.getEmptySearch<Stock_Record>();
		ss.ge.created = start;
		ss.le.created = end;
		ss.eq.movement_type = 'ADJUSTMENT';
		ss.sort_order = ['id_ASC'];
		ss.eq.store_id = resolveReportStoreId( this.stock_record_search.eq.store_id,
			this.rest.current_user.store_id, this.rest.current_permission.global_add_stock );

		this.is_generating_report = true;
		this.report_progress = 0;

		let update_lambda = (counter: number, total: number) =>
		{
			this.report_progress = total > 0 ? Math.round( ((counter+1)/total)*100 ) : 0;
		};

		if( this.report_subscription )
			this.report_subscription.unsubscribe();

		this.report_subscription = this.rest.stock_record_info
		.searchAllWithProgress( ss, STOCK_RECORD_EXPORT_PAGE_SIZE, false, update_lambda )
		.subscribe((response)=>
		{
			let m = new Map<number,StockRecordInfo>();

			for(let i of response.data)
			{
				if( m.has( i.stock_record.item_id ) )
				{
					let sri = m.get( i.item.id );
					sri.stock_record.qty = i.stock_record.qty;
				}
				else
				{
					m.set(i.item.id, i );
				}
			}

			let a:Array<StockRecordInfo> = Array.from( m.values());

			a.sort((a,b)=>{
				return a.stock_record.id > b.stock_record.id ? 1 : -1;
			});

			let rows:any[] = a.map(i=> {
				return {
					id: i.stock_record.id,
					Categoría: i?.category?.name,
					Artículo: i.item.name,
					Sucursal: i.store.name,
					'Cantidad Inicial': i.stock_record.previous_qty,
					'Ajuste': i.stock_record.qty,
					Diferencia: i.stock_record.qty - i.stock_record.previous_qty
				}
			});
			let str = Utils.getMysqlStringFromLocalDate(new Date() ).substring(0,10)+'.xlsx';
			let headers:string[] = [
				'Categoría','Artículo', 'Sucursal',
				'Cantidad Inicial', 'Ajuste', 'Diferencia'
			];
			ExcelUtils.array2xlsx( rows, str, headers );
			this.is_generating_report = false;
			this.show_modal_report = false;

		},(error)=>{
			this.is_generating_report = false;
			this.showError(error);
		});

		this.subs.sink = this.report_subscription;
	}

}
